import './js/main';
import './scss/main.scss';
import './tailwind/tailwind.css';
